export const makeRequest = async (url: string, options?: RequestInit, abortController: AbortController | null = null) => {
  const signal = abortController?.signal

  try {
    const response = await fetch(url, {...options, signal})
    console.log(response)
    if (!response.ok) {
      throw new Error(`Request failed with status ${response.status}`)
    }
    return response
  } catch (error) {
    if (error instanceof Error && error.name === "AbortError") {
      console.log("Previous fetch aborted.")
    } else {
      console.error("An error occurred:", error)
    }

    throw error
  }
}

